import { CasualPassword } from '../types'

export function validateCasualPassword(password: CasualPassword, _t: CallableFunction) {
  const errors: { [key: string]: string } = {}

  if (!password.content?.trim()) {
    errors.content = _t('field-required')
  }

  return errors
}

export function maskCasualPasswordContent(content: string) {
  if (content.length === 0) {
    return '-'
  }

  const lengthToHide = Math.min(4, Math.floor(content.length / 2))
  const visiblePart = lengthToHide > 1 ? content.slice(-1 * lengthToHide) : ''
  const maskedPart = '•'.repeat(6)

  return `${maskedPart}${visiblePart}`
}
